import { useId } from 'react';
import { type PictogramIconProps } from './types';

// menu_horizontal_lines
export const Waves = ({ color }: PictogramIconProps) => {
  const maskId = useId();

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="54"
        height="54"
      >
        <rect width="53.5273" height="53.1091" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M9.33129 39.023C8.89916 39.023 8.53703 38.8639 8.24488 38.5456C7.9524 38.2276 7.80615 37.8334 7.80615 37.3628C7.80615 36.8925 7.9524 36.4985 8.24488 36.1805C8.53703 35.863 8.89916 35.7042 9.33129 35.7042H40.8507C41.2828 35.7042 41.645 35.8632 41.9371 36.1811C42.2296 36.4994 42.3758 36.8938 42.3758 37.3644C42.3758 37.8347 42.2296 38.2288 41.9371 38.5467C41.645 38.8642 41.2828 39.023 40.8507 39.023H9.33129ZM9.33129 28.2142C8.89916 28.2142 8.53703 28.055 8.24488 27.7368C7.9524 27.4185 7.80615 27.0242 7.80615 26.554C7.80615 26.0834 7.9524 25.6893 8.24488 25.3717C8.53703 25.0538 8.89916 24.8949 9.33129 24.8949H40.8507C41.2828 24.8949 41.645 25.054 41.9371 25.3723C42.2296 25.6906 42.3758 26.0848 42.3758 26.5551C42.3758 27.0257 42.2296 27.4198 41.9371 27.7373C41.645 28.0552 41.2828 28.2142 40.8507 28.2142H9.33129ZM9.33129 17.4048C8.89916 17.4048 8.53703 17.2459 8.24488 16.9279C7.9524 16.6097 7.80615 16.2152 7.80615 15.7446C7.80615 15.2744 7.9524 14.8803 8.24488 14.5624C8.53703 14.2448 8.89916 14.0861 9.33129 14.0861H40.8507C41.2828 14.0861 41.645 14.2452 41.9371 14.5635C42.2296 14.8814 42.3758 15.2757 42.3758 15.7463C42.3758 16.2165 42.2296 16.6106 41.9371 16.9285C41.645 17.2461 41.2828 17.4048 40.8507 17.4048H9.33129Z"
          fill={color ?? 'currentColor'}
        />
        <path
          d="M20.073 11.5645C22.2639 11.5646 24.033 13.3259 24.033 15.4902C24.0329 17.6546 22.2639 19.4158 20.073 19.416C17.8819 19.416 16.1121 17.6547 16.1121 15.4902C16.1121 13.3258 17.8819 11.5645 20.073 11.5645Z"
          fill="white"
          stroke={color ?? 'currentColor'}
        />
        <path
          d="M31.2246 22.6288C33.4155 22.629 35.1846 24.3902 35.1846 26.5546C35.1846 28.7189 33.4155 30.4802 31.2246 30.4803C29.0335 30.4803 27.2637 28.719 27.2637 26.5546C27.2637 24.3901 29.0335 22.6288 31.2246 22.6288Z"
          fill="white"
          stroke={color ?? 'currentColor'}
        />
        <path
          d="M20.073 33.6932C22.2639 33.6934 24.033 35.4547 24.033 37.619C24.0329 39.7833 22.2639 41.5446 20.073 41.5448C17.8819 41.5448 16.1121 39.7835 16.1121 37.619C16.1121 35.4546 17.8819 33.6932 20.073 33.6932Z"
          fill="white"
          stroke={color ?? 'currentColor'}
        />
      </g>
    </svg>
  );
};
